function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function IncompletePets({
  width = 26,
  height = 29,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M17.107.848h-9.98C4.007.836 1.45 3.234 1.377 6.242v15.497c-.07 3.056 2.443 5.59 5.612 5.657.047 0 .092.002.138 0h11.984c3.14-.123 5.616-2.625 5.593-5.657V8.479L17.107.849z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M16.713.83v4.208c0 2.054 1.722 3.72 3.852 3.725h4.132M16.432 19.069h-8.1M13.365 13.641H8.33",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=IncompletePets.js.map